import { render, staticRenderFns } from "./full-draft-program.vue?vue&type=template&id=5d6de1e8&scoped=true"
import script from "./full-draft-program.vue?vue&type=script&lang=js"
export * from "./full-draft-program.vue?vue&type=script&lang=js"
import style0 from "./full-draft-program.vue?vue&type=style&index=0&id=5d6de1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6de1e8",
  null
  
)

export default component.exports